// extracted by mini-css-extract-plugin
var _1 = "TopicViewHeader-module__ancestorsContainer--v_s04";
var _2 = "TopicViewHeader-module__animateUploadProgressBarWidth--mWlxx";
var _3 = "TopicViewHeader-module__animatedBackground--HNNM_";
var _4 = "TopicViewHeader-module__container--uno9s";
var _5 = "TopicViewHeader-module__controls--ugN9r";
var _6 = "TopicViewHeader-module__description--o5E4K";
var _7 = "TopicViewHeader-module__hasBanner--b5aHc";
var _8 = "TopicViewHeader-module__isEditing--R2VXL";
var _9 = "TopicViewHeader-module__overflownControls--_u9xk";
export { _1 as "ancestorsContainer", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "controls", _6 as "description", _7 as "hasBanner", _8 as "isEditing", _9 as "overflownControls" }
